import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Normalize FastAPI/Square error `detail` (which may be a string, an object with
// `message`, or a list of Pydantic/Square error dicts) into a single string so
// call sites can safely pass it to toast.error() without crashing React.
function normalizeDetail(d) {
    if (!d) return "";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) {
        return d.map(x => x?.detail || x?.msg || x?.message || "").filter(Boolean).join("; ")
            || "Request failed";
    }
    if (typeof d === "object") return d.message || d.detail || d.msg || "Request failed";
    return String(d);
}

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("icfw_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            localStorage.removeItem("icfw_token");
            localStorage.removeItem("icfw_user");
        }
        if (err.response?.data?.detail !== undefined) {
            err.response.data.detail = normalizeDetail(err.response.data.detail);
        }
        return Promise.reject(err);
    }
);
